import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import { CategoryPage } from "@/components/site/CategoryPage";
import { categoryBySlug } from "@/components/site/seo";

const category = categoryBySlug("account-executive-jobs")!;

export const Route = createFileRoute("/account-executive-jobs")({
  head: () => pageHead("/account-executive-jobs"),
  component: () => <CategoryPage category={category} />,
});
